export const posthogConfig = {
  enabled: true,
  apiKey: 'phc_DLHMLlobE7EXNeC7d3ctPTffzB6xe5kWixiYLjUiioJ',
  apiHost: 'https://us.i.posthog.com',
};
